// 开发环境api域名
// const baseApiUrl = 'https://news4.localhost/index.php/api/v1/blogApi/'

// 生产环境api域名
export const baseApiUrl = 'https://scoretv.cc/index.php/api/v1/blogApi/'

export const apikey = '123456'

// 图片库
export const baseImg = ''